export function createPanelFrame(node, fallbackTitle) {
  const root = document.createElement('div');
  root.className = 'ew-panel';

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = resolveTitle(node, fallbackTitle);

  const meta = document.createElement('span');
  meta.className = 'ew-header-meta';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, meta, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  root.append(header, body);
  return { root, header, body, titleEl: title, metaEl: meta };
}

export function resolveTitle(node, fallbackTitle) {
  return node?.props?.title || node?.data?.title || fallbackTitle || 'Panel';
}

export function createBadge(text, tone = 'info') {
  const badge = document.createElement('span');
  badge.className = `ew-badge ew-badge-${tone}`;
  badge.textContent = text;
  return badge;
}

export function createMetric(labelText, valueText) {
  const wrap = document.createElement('div');
  wrap.className = 'ew-metric';
  const label = document.createElement('span');
  label.className = 'ew-metric-label';
  label.textContent = labelText;
  const value = document.createElement('span');
  value.className = 'ew-metric-value';
  value.textContent = valueText;
  wrap.append(label, value);
  return wrap;
}

export function formatPercent(value, digits = 1) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0%';
  return `${(n * 100).toFixed(digits)}%`;
}

export function formatNumber(value, digits = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toFixed(digits);
}

export function toNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function clamp(value, min, max) {
  if (!Number.isFinite(value)) return min;
  return Math.min(max, Math.max(min, value));
}

export function formatDuration(seconds) {
  const s = toNumber(seconds, 0);
  if (s < 60) return `${s.toFixed(1)}s`;
  const mins = Math.floor(s / 60);
  const rem = s % 60;
  return `${mins}m ${rem.toFixed(0)}s`;
}
